// extracted by mini-css-extract-plugin
module.exports = {"top":"ViewHead_top__xbYEU","icon":"ViewHead_icon__1hEFL","topDocument":"ViewHead_topDocument__27FH-","title":"ViewHead_title__RSQZy"};